import styled from '@emotion/styled';
import UnstyledButton from '@embed/components/common/UnstyledButton';
import { PlayerButton } from '@player/components/PlayerButton';
export const EmailEmbedModalWrapper = styled.div `
  position: relative;
  background: var(--player-modal-background, var(--gray3));
  color: var(--player-modal-font-color, white);
  padding: 22px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  border-radius: 12px;
  z-index: 5;
`;
export const Heading = styled.span `
  font-size: 18px;
  line-height: 25px;
  margin-bottom: ${({ marginBottom }) => `${marginBottom}px`};
  font-style: normal;
  font-weight: 600;
`;
export const Subheading = styled.span `
  font-size: 14px;
  line-height: 19px;
  margin-bottom: ${({ marginBottom }) => `${marginBottom || 8}px`};
  font-weight: normal;
  text-align: center;
`;
export const HeadingWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 28px;
`;
export const RadioGroup = styled.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  row-gap: 16px;
  column-gap: 40px;
`;
export const RadioLabel = styled.label `
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  padding-left: 6px;
`;
export const DividerLine = styled.div `
  height: 1px;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 24px;
  background-color: #9b9b9b;
`;
export const CopyCodeButton = styled(PlayerButton) `
  border-radius: 6px;
  width: 249px;
  margin: 50px 0 13px;
`;
export const RadioButton = styled.input `
  accent-color: #0f6bff;

  input[type='radio'] {
    font: 30px;
  }
`;
export const RadioButtonWrapper = styled.div `
  display: flex;
  align-items: center;

  input[type='radio'] {
    width: 18px;
    height: 18px;
    margin: 0;
  }
`;
export const CloseModalButton = styled(UnstyledButton) `
  position: absolute;
  top: 0;
  right: 0;
  height: 40px;
  width: 40px;
  > img {
    width: 100%;
    height: 100%;
    color: blue;
  }
`;
export const ContentWrapper = styled.div `
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
